var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0.910889C3.04 0.910889 1.6 2.33663 1.6 4.07921V10.4158C1.6 11.2561 1.93714 12.062 2.53726 12.6562C3.13737 13.2504 3.95131 13.5842 4.8 13.5842H14.4V16.7525H12.8C11.92 16.7525 11.2 17.4653 11.2 18.3366H0V21.5049H11.2C11.2 22.3762 11.92 23.0891 12.8 23.0891H19.2C20.08 23.0891 20.8 22.3762 20.8 21.5049H32V18.3366H20.8C20.8 17.4653 20.08 16.7525 19.2 16.7525H17.6V13.5842H27.2C28.976 13.5842 30.4 12.1743 30.4 10.4158V4.07921C30.4 3.23892 30.0629 2.43304 29.4627 1.83887C28.8626 1.24469 28.0487 0.910889 27.2 0.910889H4.8ZM6.4 5.66336H9.6V8.83168H6.4V5.66336ZM12 5.66336H15.2V8.83168H12V5.66336ZM17.6 5.66336H20.8V8.83168H17.6V5.66336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernet);
export default __webpack_public_path__ + "static/media/ethernet.9bab5a759d308f5cb8ccb0623bdaf9e8.svg";
export { ForwardRef as ReactComponent };